import React, { Component } from 'react'
import Link from '../utils/link'

import Cart from './cart'

import Logo from '../assets/images/logo.png'
import LongLogo from '../assets/images/long-logo.png'

class Header extends Component {

  prevScrollPos = 0

  state = {
    menuActive: false,
    visible: false,
    scrolled: false,
  }

  // Adds an event listener when the component is mount.
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  // Remove the event listener when the component is unmount.
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  // Hide or show the menu.
  handleScroll = () => {
    const currentScrollPos = window.pageYOffset
    const visible = this.prevScrollPos < currentScrollPos && currentScrollPos > 100;
    const scrolled = currentScrollPos > window.innerHeight
    this.prevScrollPos = currentScrollPos

    this.setState({ visible, scrolled })
  }

  _hideOffCanvas = () => {
    this.setState({ menuActive: false })
  }

  _toggleOffCanvas = () => {
    this.setState({ menuActive: !this.state.menuActive })
    document.querySelector('body').classList.toggle('menu-open')
  }

  render() {
    const { menuActive, visible, scrolled } = this.state
    let props = {
      onClick: this._hideOffCanvas,
    }
    let { 
      pathname,
      isCartOpen,
      setIsCartOpen,
      cartRequest,
      cartCount,
      checkout,
      updateQuantityInCart,
      removeLineItemInCart
    } = this.props

    const toggleIsCartExpanded = () => {
      setIsCartOpen(!isCartOpen)
    }

    let className = 'header'
    if (visible) className += ' header--hidden'
    if (scrolled) className += ' header--scrolled'
    if (menuActive) className += ' header--menu-active'

    return (
      <>
        <header className={className}>
          <div className='header__inner'>
            <Link to='/' className='header__logo'>
              <span className='mobile'>Emily Gillis</span>
              <span className='desktop'>Emily Gillis<br />Interior Design</span>
            </Link>
            <div className='header__nav'>
              <ul>
                <li><Link to='/shop'>Shop</Link></li>
                <li onClick={toggleIsCartExpanded}>Cart ({cartCount})</li>
                <li><Link to='/contact'>Contact</Link></li>
              </ul>
              <ul>
                <li><Link to='/services'>Services</Link></li>
                <li><Link to='/projects'>Projects</Link></li>
                <li><Link to='/about'>About</Link></li>
              </ul>
            </div>
            <button className={ this.state.menuActive ? 'hamburger active' : 'hamburger' } onClick={this._toggleOffCanvas}>
              <span className='lines'></span>
            </button>
          </div>
        </header>

        <div className={`off-canvas ${menuActive ? 'active' : ''}`}>
          <nav className='off-canvas__nav'>
            <ul>
              <li {...props}><Link to='/services'>Services</Link></li>
              <li {...props}><Link to='/projects'>Projects</Link></li>
              <li {...props}><Link to='/about'>About</Link></li>
              <li {...props}><Link to='/contact'>Contact</Link></li>
              <li {...props}><Link to='/shop'>Shop</Link></li>
              <li onClick={toggleIsCartExpanded}>Cart ({cartCount})</li>
            </ul>
          </nav>
        </div>
        <Cart
          toggleIsCartExpanded={toggleIsCartExpanded}
          isCartOpen={isCartOpen}
          cartRequest={cartRequest}
          cartCount={cartCount}
          checkout={checkout}
          updateQuantityInCart={updateQuantityInCart}
          removeLineItemInCart={removeLineItemInCart}
        />
      </>
    )
  }
}

export default Header
